import { Box, Typography } from '@mui/material';

import AdditionalSectionText from '../AdditionalSectionText/AdditionalSectionText';

import {
  styledCrossedPrice,
  styledCrossedPriceContent,
  styledDetailsTitleWrapper,
  styledReceiptDetailsTitleWrapper,
} from './ReceiptDetailsTitleSection.styled';
import { Maybe } from 'graphql/jsutils/Maybe';

interface ReceiptDetailsTitleSectionProps {
  title: string;
  price?: string | number;
  currency?: Maybe<string>;
  oldPrice?: string | number;
  additionalText?: string;
}

export default function ReceiptDetailsTitleSection({
  title,
  price,
  currency,
  additionalText,
  oldPrice,
}: ReceiptDetailsTitleSectionProps) {
  const showOldPrice =
    oldPrice !== undefined && oldPrice !== null && oldPrice !== '';
  const showPrice =
    price !== undefined && price !== null && price !== '';

  return (
    <Box sx={styledReceiptDetailsTitleWrapper}>
      <Box sx={styledDetailsTitleWrapper}>
        <Typography>{title}</Typography>
        {showPrice && (
          <Box sx={styledCrossedPrice}>
            {showOldPrice && (
              <Typography variant="body5" sx={styledCrossedPriceContent}>
                {currency}
                {oldPrice}
              </Typography>
            )}
            <Typography variant="body5">
              {currency}
              {price}
            </Typography>
          </Box>
        )}
      </Box>
      {additionalText && (
        <AdditionalSectionText>{additionalText}</AdditionalSectionText>
      )}
    </Box>
  );
}
